module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Target-fd56170568dc97e7fb850a4467cd7f3a00c4559bcd61c414d1ab15cadc771894.svg";